import { useMutation } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";

// POST /api/portal/content/:assetId/view
//
// pessimistic: no UI feedback either way. Failures log silently — the user
// shouldn't see an error toast for an analytics ping that doesn't affect
// what they were doing. Content-view rows are best-effort by design.
export function useLogContentView() {
  return useMutation<{ ok: true }, ApiClientError, string>({
    mutationFn: (assetId) =>
      apiFetch<{ ok: true }>(`/portal/content/${assetId}/view`, { method: "POST" }),
    onError: (err) => {
      console.warn("[content] view log failed:", err.message);
    },
  });
}
